import { Subject } from 'rxjs';
import { AppConfig } from '@tech-utils/app-config.service';
//import { ClientDataApiRestInterface } from './../../../../core/interfaces/client-data-apirest.interface';
import { ClientDataApiRestInterface } from '@techrules/portallib';
import { CommonService } from '@tech-services/common.service';
import { formatDate } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Router } from '@angular/router';
import { SessionService } from '@tech-services/session.service';
import { Utils } from '@tech-utils/utils';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'tech-riskprofile',
  templateUrl: './riskprofile.component.html',
  styleUrls: ['./riskprofile.component.scss'],
})
export class RiskprofileComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject();
  isLoading: boolean = false;
  public domain: string = AppConfig.settings.domain;
  public customTheme = localStorage.getItem('ThemeImg');

  profileSelected: any;
  profileName: string;

  testId: string;
  extendedTest: boolean;
  isReprofile: boolean;
  expireReProfile: string;
  isReprofileExpired: boolean;

  constructor(
    private common: CommonService,
    private translate: TranslateService,
    private router: Router,
    private session: SessionService
  ) {}

  ngOnInit() {
    this.extendedTest = AppConfig.settings.extendedTest;

    const profiles = [
      {
        id: 1,
        description: 'k002491',
      },
      {
        id: 2,
        description: 'k002492',
      },
      {
        id: 3,
        description: 'k002493',
      },
      {
        id: 4,
        description: 'k002494',
      },
      {
        id: 5,
        description: 'k002495',
      },
    ];

    this.common.clientDataInitialSource
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: ClientDataApiRestInterface) => {
        if (Object.keys(data).length > 0) {
          const _investorProfile = data.InvestorProfile;
          // console.log(_investorProfile);
          // testId
          this.testId = _investorProfile.TestId;

          // Reprofile
          this.isReprofile = _investorProfile.AllowReprofile;
          this.isReprofileExpired = _investorProfile.TestExpired;
          this.profileName = data.InvestorProfile.ProfileName;
          const i1 = this.translate.instant('k003114');
          const i2 = this.translate.instant('k003115');

          if (_investorProfile.TestExpirationDate != '1900-01-01') {
            this.expireReProfile = Utils.formatString(
              this.isReprofileExpired ? i2 : i1,
              [
                formatDate(
                  _investorProfile.TestExpirationDate,
                  'dd/MM/yyyy',
                  'en_GR'
                ),
              ]
            );
          }

          // profile
          const des = profiles[Number(data.InvestorProfile.ProfileId) - 1];
          // this.profileSelected = profiles[data.ProfileId - 1];
          this.isLoading = true;

          this.translate.get(des.description).subscribe((text: string) => {
            des.description = text;
            this.profileSelected = des;
          });
        }
      });
  }

  goToRetake() {
    this.common.showMenuSource.next(false);
    this.session.operativeInit = 'dashboard';
    this.router.navigate(['/questionnaire']);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
